import { apiHelper } from '@/utils';
import { API } from '@/constants';

const URL = `${API.BASE_URL_API}/v1`;
export const catalogSubcategoryService = { getAll, store, show, update, updateStatus, softDelete };
export function getAll(filter = {}) {
    const params = { page: filter.pageNumber, size: filter.pageSize, sortBy: filter.sortBy, orderBy: filter.orderBy };
    if (filter.searchArray?.length) params.search_words = filter.searchArray;
    return apiHelper(URL).get('/catalog-subcategories', { params });
}
function formData(data, method = null) {
    const value = new FormData();
    value.append('name', data.name);
    value.append('catalog_category_uuid', data.catalogCategoryUUID);
    if (data.sequence !== null && data.sequence !== '') value.append('sequence', data.sequence);
    value.append('description', data.description);
    if (data.icon instanceof File) value.append('icon', data.icon);
    if (method) value.append('_method', method);
    return value;
}
export function store(data) {
    return apiHelper(URL).post('/catalog-subcategories', formData(data));
}
export function show(uuid) {
    return apiHelper(URL).get(`/catalog-subcategories/${uuid}`);
}
export function update(data) {
    return apiHelper(URL).post(`/catalog-subcategories/${data.uuid}`, formData(data, 'PUT'));
}
export function updateStatus(uuid, isActive) {
    return apiHelper(URL).patch(`/catalog-subcategories/${uuid}`, { is_active: isActive ? 1 : 0 });
}
export function softDelete(uuid) {
    return apiHelper(URL).patch(`/catalog-subcategories/delete/${uuid}`);
}
